import { isStreamIQ, isToya } from '@/shared/lib'

export async function getUseCategoriesForFilteringHook() {
    if (isStreamIQ()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/streamiq/shared/hooks/useCategoriesFilteringStreamIq')
            return module.useCategoriesForFilteringStreamIQ
        } catch (error) {
            console.warn(
                'useCategoriesFilteringStreamIq module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }

    if (isToya()) {
        try {
            const module =
                await require('@/clients/toya/hooks/useCategoriesForFiltering')
            return module.useCategoriesForFiltering
        } catch (error) {
            console.warn(
                'useCategoriesForFiltering module is missing. Toya-specific features are disabled.',
                error
            )
            return null
        }
    }
}
